import { Group } from "@tine/designsystem-ui-react";
import { cn } from "@tine/designsystem-utils";

import type { RecipeStepType } from "../../../common/types/recipeTypes";
import { hasContent } from "../../../common/utils";

import StepTip from "./StepTip";
import StepVideo from "./StepVideo";

type StepProps = {
   step: RecipeStepType;
   stepNumber: number;
};

const Step = ({ step, stepNumber }: StepProps) => {
   const { instruction, video, tip } = step;
   const styles = cn({
      "mb-6": hasContent(tip),
      "mb-12": !hasContent(tip)
   });
   return (
      <>
         <Group align="start" justify="start" gap={0} className={styles}>
            <div className="mr-7 flex min-h-9 min-w-9 items-center justify-center rounded-[50%] bg-surface-default-inverted font-semibold text-ink-brand-inverted">
               {stepNumber}
            </div>
            <div className="mt-[6px]">{instruction}</div>
         </Group>
         {hasContent(tip) && <StepTip className="mb-12 ml-16" tip={tip} variant="information" lightbulbIcon={true} />}
         {hasContent(video) && (
            <div className="py-3">
               <StepVideo video={video} />
            </div>
         )}
      </>
   );
};

export default Step;
